import { useSelector } from "react-redux";

function CommitteeDescriptionInMainPage() {
  const { data: homeContet } = useSelector(
    (x) => x?.home?.homePageContentResponse
  );

  return (
    <section
      className="why-BCSP-committee"
      dangerouslySetInnerHTML={{
        __html: homeContet?.sectionOneDescription,
      }}
    ></section>
    // <section className="why-BCSP-committee">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-lg-12">
    //         <div
    //           className="why-bcsp-content"
    //           data-sal="slide-up"
    //           data-sal-duration="300"
    //         >
    //           <h1 className="main-title">{homeContet?.sectionOneTitle}</h1>
    //           <p
    //             dangerouslySetInnerHTML={{
    //               __html: homeContet?.sectionOneDescription,
    //             }}
    //           ></p>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}

export default CommitteeDescriptionInMainPage;
